import React, { useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import styled from "styled-components";
import {
  addSpecialHospitalityItem,
  MeetingRoomBookingViewPanel,
  setDialogPanel
} from "../../models/meeting-room-booking-dialog.duck";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useTranslation } from "react-i18next";
import { BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import TextField from '@shared/ui/atoms/TextField';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { isEmpty } from '@shared/utils/StringUtils';
import { failureNotification } from '@shared/store/notification.duck';
import { isAnyNumber } from '@shared/utils/TypeUtils';

export function AddSpecialItemsPanel(props: Props) {
  const dispatch = useDispatch();
  const textRef = useRef<any>(null);
  const {t} = useTranslation();
  const [description, setDescription] = useState('');
  const [foodCostString, setFoodCostString] = useState('0');
  const [quantity, setQuantity] = useState(0);

  const onCancelClicked = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.MeetingRoomBooking));
    setDescription('');
    setFoodCostString('0.00');
    setQuantity(0);
  }

  const onConfirmClicked = () => {
    if (isEmpty(description)) {
      dispatch(failureNotification('Enter description'));
      return;
    }
    if (quantity < 1) {
      dispatch(failureNotification('Enter quantity greater than 0'));
      return;
    }
    if (!isAnyNumber(foodCostString)) {
      dispatch(failureNotification('Cost must be a number'));
      return;
    }
    if (description) {
      dispatch(addSpecialHospitalityItem({item: {description, price: parseFloat(foodCostString), quantity}}))
      dispatch(setDialogPanel(MeetingRoomBookingViewPanel.MeetingRoomBooking));
      setDescription('');
      setFoodCostString('0.00');
      setQuantity(0);
    }
  }

  return (
    <>
      <Content>
        <HeadlineMedium style={{marginBottom: 24}}>{t('hospitality.special-hospitality-item-title')}</HeadlineMedium>
        <BodyRegular style={{marginBottom: 8}} weight={600} colour={Colours.darkGrey}>{t('general.description')}</BodyRegular>
        <TextArea ref={textRef}
                  defaultValue={''}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)} />
        <Row>
          <TextField onChange={(val: string) => setFoodCostString(val)}
                     style={{maxWidth: 100}}
                     value={foodCostString}
                     label={'hospitality.food-cost'} />

          <Column style={{marginLeft: 32}}>
            <BodyRegular weight={600} style={{marginBottom: 8}} colour={Colours.darkGrey}>{t('hospitality.quantity')}</BodyRegular>
            <Quantity>
              <IconButton color={'grey'} icon={IconTypes.Minus} onClick={() => setQuantity(Math.max(0, quantity - 1))} />
              <BodySmall>{quantity}</BodySmall>
              <IconButton icon={IconTypes.Add} onClick={() => setQuantity(Math.max(0, quantity + 1))} />
            </Quantity>
          </Column>
        </Row>
        <Controls>
          <OutlineButton text={'button.cancel'} click={onCancelClicked} />
          <PrimaryButton text={'hospitality.add-item'} click={onConfirmClicked} />
        </Controls>
      </Content>
    </>
  )
}

interface Props {
}


const Content = styled.div`
  padding: 24px 56px 24px 56px;
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`

const Row = styled.div`
  display: flex;
`

const Quantity = styled.div`
  display: flex;
  align-items: center;
  .iconButton__button {
    height: 32px;
    width: 32px;
    border: 1px solid ${Colours.darkGrey};
    border-radius: 100%;
    margin: 0 8px;
    i {
      font-size: 14px;
    }
  }
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 8px;
  padding: 4px 8px;
  font-size: 16px;
  font-family: "soleil", sans-serif;
  white-space: pre-wrap;
`

